import { Component, ViewChild } from "@angular/core";
import { ModalComponent } from "../modal.component/modal.component";
import { TicketPackage } from "src/app/model/interfaces/ticket-package";
import { PriceService, PrizesService } from "../../../../services";
import { PrizesTable } from "src/app/services/prizes.service";
import { TrackingFacadeService } from "src/app/services/tracking/tracking-facade.service";

@Component({
    selector: "app-product-info-modal",
    templateUrl: "./product-info-modal.component.html",
    styleUrls: ["./product-info-modal.component.scss"],
})
export class ProductInfoModalComponent {
    @ViewChild("modal") public modal: ModalComponent;

    public isPackage: boolean;
    public isTicket: boolean;
    public ticketPackage: TicketPackage;
    public prizesTable: PrizesTable;

    pricePrMonth: any;
    pricePrHalfYear: any;
    totalPricePrMonth: any;

    public constructor(
        private prizesService: PrizesService,
        private priceService: PriceService,
        private trackingFacadeService: TrackingFacadeService
    ) { }

    public ngOnInit() {
        this.ticketPackage = null;
        this.isPackage = true;
        this.isTicket = false;
    }

    public open(data: any) {
        let ticketPackage = data;
        this.prizesTable = this.prizesService
            .getPrizesTable()
            .find((entry) => entry.name == ticketPackage.Name);

        if (ticketPackage.TicketPackageContents) {
            this.isPackage = true;
            this.isTicket = false;

            data.TicketPackageContents.forEach((contents, index) => {
                this.priceService
                    .getPriceByShareType(contents.TicketShareType)
                    .subscribe((price) => {
                        ticketPackage.TicketPackageContents[
                            index
                        ].pricePrMonth =
                            price.subscriptionSingleMonth *
                            contents.NumberOfTickets;
                        this.pricePrMonth = price.subscriptionSingleMonth;
                        this.pricePrHalfYear = price.subscriptionSixMonths;
                    });
            });

            this.priceService
                .getPriceByPackage(ticketPackage)
                .subscribe((p) => { this.totalPricePrMonth = p.subscriptionSingleMonth; });
        } else {
            this.isPackage = false;
            this.isTicket = true;
            this.priceService
                .getPriceByShareType(ticketPackage)
                .subscribe((price) => { this.pricePrMonth = price.subscriptionSingleMonth; });
        }

        this.ticketPackage = ticketPackage;
        this.modal.open();
        this.trackModalEvent();
    }

    public closeModal() {
        this.modal.close();
    }

    private trackModalEvent(): void {
        const path = window.location.href;
        const label = this.isTicket === true ? '(Lod)' : '(Lodpakke)'
        this.trackingFacadeService.shopWinchanceOpened(path, `Vinderchance modal ${label}`);
    }
}
